"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleStep = void 0;
const Step_1 = require("../types/Step");
const Utils_1 = require("../Utils");
class ScheduleStep extends Step_1.Step {
    constructor(state) {
        super();
        this.FORM_STATE = state;
        this.init();
    }
    init() {
        // stuff here
        if (this.FORM_STATE.config.devMode) {
            console.info(`[OF] ScheduleStep loaded.`);
        }
    }
    onShow() {
        if (this.isFirstShow()) {
            // first show event
            (0, Utils_1.sendEvent)('firstShowSchedule', this.FORM_STATE);
            // trigger autofill
            if (this.FORM_STATE.config.autofill) {
            }
        }
    }
    validate() {
        return false;
    }
}
exports.ScheduleStep = ScheduleStep;
